"use strict";

var _slicedToArray = require("/codebuild/output/src1656618240/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _defineProperty = require("/codebuild/output/src1656618240/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var React = _interopRequireWildcard(require("react"));

var _configProvider = require("../config-provider");

var _style = _interopRequireDefault(require("./style"));

var _colors = require("../_util/colors");

var Ribbon = function Ribbon(_ref) {
  var _ref2;

  var className = _ref.className,
      customizePrefixCls = _ref.prefixCls,
      style = _ref.style,
      color = _ref.color,
      children = _ref.children,
      text = _ref.text,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'end' : _ref$placement;

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var prefixCls = getPrefixCls('ribbon', customizePrefixCls);
  var colorInPreset = (0, _colors.isPresetColor)(color, false);
  var ribbonCls = (0, _classnames.default)(prefixCls, "".concat(prefixCls, "-placement-").concat(placement), (_ref2 = {}, _defineProperty(_ref2, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _defineProperty(_ref2, "".concat(prefixCls, "-color-").concat(color), colorInPreset), _ref2), className);

  var _ref3 = (0, _style.default)(prefixCls),
      _ref4 = _slicedToArray(_ref3, 2),
      wrapSSR = _ref4[0],
      hashId = _ref4[1];

  var colorStyle = {};
  var cornerColorStyle = {};

  if (color && !colorInPreset) {
    colorStyle.background = color;
    cornerColorStyle.color = color;
  }

  return wrapSSR( /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)("".concat(prefixCls, "-wrapper"), hashId)
  }, children, /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)(ribbonCls, hashId),
    style: Object.assign(Object.assign({}, colorStyle), style)
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-text")
  }, text), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-corner"),
    style: cornerColorStyle
  }))));
};

if (process.env.NODE_ENV !== 'production') {
  Ribbon.displayName = 'Ribbon';
}

var _default = Ribbon;
exports.default = _default;